import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 10, viewBox: "0 0 7 10", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.323744 4.18368L4.16826 0.339167C5.2508 -0.753485 7.1427 1.04737 6.0197 2.16025L3.1869 4.99306L6.0197 7.88656C7.18317 9.05003 5.13951 10.6688 4.17838 9.70765L0.333861 5.86313C-0.111294 5.35727 -0.111294 4.61872 0.333861 4.18368L0.323744 4.18368Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgChevron);
export default ForwardRef;
